var React = require('react');

function BookOpen (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.5 3h-1.5v-1.5c0-.276-.224-.5-.5-.5h-6c-1.435 0-2.445.475-3 1.393-.555-.918-1.565-1.393-3-1.393h-6c-.276 0-.5.224-.5.5v1.5h-1.5c-.276 0-.5.224-.5.5v16c0 .276.224.5.5.5h6c.902 0 3 .244 3 2.5 0 .276.224.5.5.5h3c.276 0 .5-.224.5-.5 0-2.256 2.098-2.5 3-2.5h6c.276 0 .5-.224.5-.5v-16c0-.276-.224-.5-.5-.5zm-8-1h5.5v15h-5.5c-1.079 0-1.916.271-2.5.8v-13.3c0-1.729.771-2.5 2.5-2.5zm-11.5 0h5.5c1.729 0 2.5.771 2.5 2.5v13.303c-.592-.527-1.433-.803-2.5-.803h-5.5v-15zm19 17h-5.5c-2.233 0-3.741 1.161-3.97 3h-2.06c-.228-1.839-1.736-3-3.97-3h-5.5v-15h1v13.5c0 .276.224.5.5.5h6c1.74 0 2.516.771 2.516 2.5 0 .276.224.5.5.5s.5-.224.5-.5c0-1.729.767-2.5 2.484-2.5h6c.276 0 .5-.224.5-.5v-13.5h1v15z"}));
}

BookOpen.defaultProps = {"version":"1","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = BookOpen;

BookOpen.default = BookOpen;
